<div class="row preferred-dist">
    <div class="col-sm-12">
        <mat-label
        >Looks like you already registered, please select one of the following Household ID?</mat-label
        >
        <mat-radio-group
        class="id-radio-group"
        [formControl]="householdIdControl"
        required
        >
        <mat-radio-button
            *ngFor="let opt of data.messageIds"
            class="id-radio-button"
            [value]="opt.text"
            >{{ opt.text }}</mat-radio-button>
        <mat-radio-button
            class="id-radio-button"
            [value]="false"
            >Create new household</mat-radio-button>
        </mat-radio-group>
    </div>
</div>

<div class="save-btn">
    <button mat-flat-button color="primary" (click)="onCancel()">
      {{ "Cancel" | translate }}
    </button>
    <button mat-flat-button color="primary" (click)="onConfirm()">
      {{ "Save" | translate }}
    </button>
  </div>